import React from 'react';
import PropTypes from 'prop-types';

import { shortFormattedTime } from 'shared/utils/formattedTime';

import theme from './CallTimer.scss';

const propTypes = { callTimerValue: PropTypes.number };

const defaultProps = {
  callTimerValue: undefined,
};

const CallTimer = ({ callTimerValue }) => (
  <div className={ theme.root }>
    { shortFormattedTime(callTimerValue) }
  </div>
);

CallTimer.propTypes = propTypes;
CallTimer.defaultProps = defaultProps;

export default CallTimer;
